import { render, staticRenderFns } from "./ProfileStudentHeader.vue?vue&type=template&id=5aa436ca&scoped=true&"
import script from "./ProfileStudentHeader.vue?vue&type=script&lang=ts&"
export * from "./ProfileStudentHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileStudentHeader.vue?vue&type=style&index=0&id=5aa436ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa436ca",
  null
  
)

export default component.exports